<template>             
    <Row>
        <Col span="4">{{orderCode}}</Col>
        <Col span="5">{{trackNo}}</Col>
        <Col span="8">{{orderCode}}</Col>
        <Col span="3">{{nodeStatus}}</Col>
    </Row> 
    <!-- <div style="white-space:nowrap;">aaaaaaa</div> -->
</template>

<script>
export default {
    name:'NewestTracNodePanel',
    props:{
            orderCode:String,
            trackNo:String,
            nodeStatus:String
        }
}
</script>
